import { Dispatch } from "@reduxjs/toolkit";
import { FileProps } from "../../../types/generic";
import {
  deleteAttachments,
  getAttachments,
  postAttachments,
} from "../../../services/cto/attachments";
import { saveFile } from "../../../utils/saveFile";
import { caseToOperateSlice } from "./slice";

const { actions } = caseToOperateSlice;

/* ATTACHMENTS */
export const downloadFile =
  ({
    attachment_id,
    file_name,
    vesselId,
    ctoId,
    shouldUseHistory,
  }: FileProps & {
    vesselId: string;
    ctoId: string;
    shouldUseHistory: boolean;
  }) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(actions.setLoadingFileId(attachment_id));
      const attachment = await getAttachments(
        vesselId,
        ctoId,
        attachment_id,
        shouldUseHistory,
      );
      saveFile(attachment, file_name);
    } finally {
      dispatch(actions.setLoadingFileId(-1));
    }
  };

export const uploadFiles =
  (
    vesselCode: string,
    ctoCode: string,
    onUploadSuccess?: () => void,
    files?: File[],
    type?: string,
  ) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(actions.setIsUploadingFiles(true));
      const formData = new FormData();
      if (files?.length) {
        files.forEach((file) => {
          formData.append("file", file);
        });
        const successIds = await postAttachments(
          vesselCode,
          ctoCode,
          formData,
          type,
        );
        if (successIds.length === files.length) {
          onUploadSuccess?.();
          return successIds;
        }
        throw new Error("Error during upload");
      }
      return [];
    } finally {
      dispatch(actions.setIsUploadingFiles(false));
    }
  };

export const deleteFile =
  (
    vesselCode: string,
    ctoCode: string,
    fileId: number,
    onDeleteSuccess?: () => void,
  ) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(actions.setIsDeletingFiles(true));
      const response = await deleteAttachments(vesselCode, ctoCode, fileId);
      if (response.message) {
        onDeleteSuccess?.();
        return response;
      }
      throw new Error("Error during delete");
    } finally {
      dispatch(actions.setIsDeletingFiles(false));
    }
  };

export const thunks = {
  downloadFile,
  uploadFiles,
  deleteFile,
};
